// Tiny markdown renderer for coach responses.
// Supports: **bold**, *italic*, `code`, bullet lines starting with -, *, • and numbered lists.
// No external deps, safe (escapes HTML then re-inserts inline styles).

function escapeHtml(str) {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function inlineFormat(line) {
  let out = escapeHtml(line);
  out = out.replace(/`([^`]+)`/g, '<code class="rounded bg-white/60 px-1 py-0.5 text-[0.85em]">$1</code>');
  out = out.replace(/\*\*([^*]+)\*\*/g, '<strong class="font-semibold">$1</strong>');
  out = out.replace(/(^|[^*])\*([^*\n]+)\*/g, '$1<em>$2</em>');
  return out;
}

export default function CoachMarkdown({ text = "" }) {
  const lines = text.split(/\n/);
  const blocks = [];
  let currentList = null;
  let paragraph = [];

  const flushParagraph = () => {
    if (paragraph.length) {
      blocks.push({ type: "p", content: paragraph.join(" ") });
      paragraph = [];
    }
  };
  const flushList = () => {
    if (currentList) {
      blocks.push(currentList);
      currentList = null;
    }
  };

  for (const raw of lines) {
    const line = raw.trim();
    if (!line) {
      flushList();
      flushParagraph();
      continue;
    }
    const bullet = line.match(/^([-*•])\s+(.*)$/);
    const numbered = line.match(/^(\d+)[.)]\s+(.*)$/);
    if (bullet || numbered) {
      flushParagraph();
      const kind = bullet ? "ul" : "ol";
      if (!currentList || currentList.type !== kind) {
        flushList();
        currentList = { type: kind, items: [] };
      }
      currentList.items.push((bullet || numbered)[2]);
      continue;
    }
    flushList();
    paragraph.push(line);
  }
  flushList();
  flushParagraph();

  return (
    <div className="space-y-3 text-[#16233D] leading-relaxed">
      {blocks.map((b, i) => {
        if (b.type === "p") {
          return (
            <p
              key={i}
              dangerouslySetInnerHTML={{ __html: inlineFormat(b.content) }}
            />
          );
        }
        const Tag = b.type === "ul" ? "ul" : "ol";
        const listCls = b.type === "ul" ? "list-disc" : "list-decimal";
        return (
          <Tag key={i} className={`${listCls} pl-5 space-y-1.5`}>
            {b.items.map((it, j) => (
              <li key={j} dangerouslySetInnerHTML={{ __html: inlineFormat(it) }} />
            ))}
          </Tag>
        );
      })}
    </div>
  );
}
